<script setup>
import { ref } from "vue";
import ArgonButton from "@/components/ArgonButton.vue";
import ArgonCheckbox from "@/components/ArgonCheckbox.vue";

defineProps({
  isVisible: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits(["accept"]);

const checked = ref(false);

const onToggle = (event) => {
  checked.value = event.target.checked;
};

const onAccept = () => {
  if (!checked.value) return;
  emit("accept");
};
</script>

<template>
  <div v-if="isVisible" class="terms-overlay">
    <div class="terms-card">
      <div class="terms-card-header">
        <h5 class="mb-0">Términos y Condiciones</h5>
      </div>
      <div class="terms-card-body">
        <p>
          Texto de ejemplo. Sustituir por el texto real de los Términos y
          Condiciones del portal antes de publicar en producción.
        </p>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
          ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
      </div>
      <div class="terms-card-footer">
        <argon-checkbox
          id="acceptTerms"
          name="acceptTerms"
          :checked="checked"
          @change="onToggle"
        >
          He leído y acepto los términos y condiciones.
        </argon-checkbox>
        <argon-button
          fullWidth
          class="mt-3"
          :disabled="!checked"
          @click="onAccept"
        >
          Aceptar
        </argon-button>
      </div>
    </div>
  </div>
</template>

<style scoped>
.terms-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 1rem;
}

.terms-card {
  background: #fff;
  border-radius: 0.5rem;
  width: 100%;
  max-width: 520px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.terms-card-header {
  padding: 1rem 1.5rem;
  border-bottom: 1px solid #e9ecef;
}

.terms-card-body {
  padding: 1rem 1.5rem;
  overflow-y: auto;
  flex: 1;
}

.terms-card-footer {
  padding: 1rem 1.5rem;
  border-top: 1px solid #e9ecef;
}
</style>
